import { Flex } from "@redotech/redo-web/flex";
import { ReactNode } from "react";

export function StickyFooter({
  children,
  bgColor = "primary",
}: {
  children: ReactNode;
  bgColor?: "primary" | "secondary";
}) {
  return (
    <Flex
      bgColor={bgColor}
      bottom="0"
      data-ui="sticky-footer"
      flexDirection="column"
      gap="none"
      pb="3xl"
      position="sticky"
      w="full"
    >
      {children}
    </Flex>
  );
}
